"use strict";
exports.__esModule = true;
exports.synthesizeBoolean = void 0;
function synthesizeBoolean(schema, options) {
    var random = options.random;
    return random() < 0.5 ? true : false;
}
exports.synthesizeBoolean = synthesizeBoolean;
